export const types = {
    SEND: 'SEND-MAIL',
    GET: 'GET-MAIL',
    MOVE: 'MOVE-MAIL',
    SAVEATTACHMENTS: 'SAVE-ATTACHMENTS'
};